import React from 'react';

interface ICleanButtonProps {
    children?: React.ReactNode;
    func?: () => void;
    func2?: () => void;
    func3?: () => void;
    stretch?: boolean;
    buttonType?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    useBg?: boolean;
    hasCursor?: boolean;
    isDragging?: boolean;
}

export const CleanButton: React.FC<ICleanButtonProps> = ({ isDragging = false, stretch = false, children, func, func2, func3, buttonType = 'button', disabled = false, useBg = false, hasCursor = true }) => {
    return (
        <button onMouseEnter={func2} onMouseLeave={func3} disabled={disabled} type={buttonType} className={`clean-btn ${hasCursor && !isDragging ? `clean-btn__cursor--pointer` : `clean-btn__cursor--grabbing`} ${stretch && 'clean-btn__stretch'}`} onClick={func}>
            {useBg ? <div className="clean-btn__bg">{children}</div> : children}
        </button>
    );
};
